'use client'

import { useQueryClient } from '@tanstack/react-query'
import { useLocale } from 'next-intl'
import { useCallback, useState } from 'react'

import { mapQueries, TMarkerSearchParams } from '@/entities/map'
import { SearchMap, useMapSearchParams } from '@/features/search-map'
import { BridgeProvider } from '@/shared/lib'
import { Language, ZLanguage } from '@/shared/model'

import { BottomSheet } from '../bottom-sheet'
import { MobileRoomList } from '../room-list'
import { MobileSearchBar } from '../search-bar'

export const MobileSearchPage = () => {
  const locale = useLocale()

  const queryClient = useQueryClient()

  const [mapInitialized, setMapInitialized] = useState(false)

  useMapSearchParams({ pathname: '/guest/search' })

  const language = (() => {
    const parsedLanguage = ZLanguage.safeParse(locale)

    if (!parsedLanguage.success) {
      return Language.KO
    }

    return parsedLanguage.data
  })()

  const handleMapInitialized = useCallback(() => {
    setMapInitialized(true)
  }, [])

  const getMarkers = useCallback(
    async (params: TMarkerSearchParams) => {
      const markers = await queryClient.fetchQuery({
        ...mapQueries.markerList(params),
      })

      return markers
    },
    [queryClient],
  )

  return (
    <>
      <MobileSearchBar />
      <BridgeProvider>
        <div className="relative mb-[85px] flex h-[50px] grow">
          <div className="relative w-full grow overflow-hidden">
            <SearchMap
              language={language}
              getMarkers={getMarkers}
              onInitialized={handleMapInitialized}
            />
          </div>
          <BottomSheet mapInitialized={mapInitialized}>
            {({ ref, onScroll }) => (
              <MobileRoomList ref={ref} onScroll={onScroll} />
            )}
          </BottomSheet>
        </div>
      </BridgeProvider>
    </>
  )
}
